import { SeverityLevel, captureException } from '@sentry/react';
import _ from 'lodash';

const sentryCaptureException = (
  message: string,
  level: SeverityLevel = 'fatal',
  extraData: Record<string, any> = {},
): void => {
  captureException(new Error(message), {
    level,
    ...(extraData && !_.isEmpty(extraData) ? { extra: extraData } : {}),
  });
};

export default sentryCaptureException;
